import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCrop: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCrop"><Path d="M16 8H8V16H16V8Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M6.5 2V5H19V17.5H22V19H19V22H17.5V19H5V6.5H2V5H5V2H6.5ZM6.5 17.5V6.5H17.5V17.5H6.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCrop;
